<!-- Recovery Password Page -->
<main class="recovery-main">

  <!-- ─── VALIDATING TOKEN VIEW ─── -->
  <section class="state-section" *ngIf="!tokenValid && !tokenExpired">
    <div class="state-icon-wrap state-icon-wrap--loading">
      <i class="fas fa-key"></i>
    </div>
    <h2 class="state-title">{{ 'RECOVERY_PASSWORD.TITLE' | translate }}</h2>
    <p class="state-sub">{{ 'RECOVERY_PASSWORD.VALIDATING_TOKEN' | translate }}</p>
  </section>

  <!-- ─── TOKEN EXPIRED VIEW ─── -->
  <section class="state-section" *ngIf="tokenExpired">
    <div class="state-icon-wrap state-icon-wrap--error">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h2 class="state-title">{{ 'RECOVERY_PASSWORD.TOKEN_EXPIRED' | translate }}</h2>
    <p class="state-sub">{{ 'RECOVERY_PASSWORD.REDIRECTING_TO_RECOVERY' | translate }}</p>
  </section>

  <!-- ─── SUCCESS VIEW ─── -->
  <section class="state-section" *ngIf="passwordReset">
    <div class="state-icon-wrap state-icon-wrap--success">
      <i class="fas fa-check-circle"></i>
    </div>
    <h2 class="state-title">{{ 'RECOVERY_PASSWORD.SUCCESS_MESSAGE' | translate }}</h2>
    <p class="state-sub">{{ 'RECOVERY_PASSWORD.REDIRECTING_TO_LOGIN' | translate }}</p>
  </section>

  <!-- ─── FORM VIEW ─── -->
  <section class="recovery-section" *ngIf="tokenValid && !passwordReset">
    <div class="recovery-content">

      <div class="recovery-heading">
        <div class="recovery-heading-icon"><i class="fas fa-key"></i></div>
        <div>
          <h1 class="recovery-title">{{ 'RECOVERY_PASSWORD.TITLE' | translate }}</h1>
          <p class="recovery-subtitle">{{ 'RECOVERY_PASSWORD.INSTRUCTIONS' | translate }}</p>
        </div>
      </div>

      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" class="recovery-card">

        <!-- General form error -->
        <div *ngIf="hasGeneralError()" class="recovery-alert recovery-alert--error">
          <i class="fa-solid fa-exclamation-circle"></i>
          {{ getGeneralError() | translate }}
        </div>

        <!-- Form-level password mismatch error -->
        <div *ngIf="hasFormError()" class="recovery-alert recovery-alert--error">
          <i class="fa-solid fa-exclamation-circle"></i>
          {{ getFormError() | translate }}
        </div>

        <!-- New Password Field -->
        <label class="recovery-label" for="password">{{ 'RECOVERY_PASSWORD.PASSWORD_LABEL' | translate }}</label>
        <div class="recovery-input-wrapper" [class.is-invalid]="hasError('password')">
          <i class="fas fa-lock recovery-input-icon"></i>
          <input
            id="password"
            type="password"
            formControlName="password"
            class="recovery-input"
            [placeholder]="'RECOVERY_PASSWORD.PASSWORD_PLACEHOLDER' | translate"
            autocomplete="new-password"
          />
        </div>
        <div *ngIf="hasError('password')" class="recovery-error">
          <i class="fas fa-exclamation-circle"></i>
          {{ getErrorMessage('password') | translate }}
        </div>

        <!-- Confirm Password Field -->
        <label class="recovery-label recovery-label--spaced" for="confirmPassword">
          {{ 'RECOVERY_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate }}
        </label>
        <div class="recovery-input-wrapper" [class.is-invalid]="hasError('confirmPassword') || hasFormError()">
          <i class="fas fa-lock recovery-input-icon"></i>
          <input
            id="confirmPassword"
            type="password"
            formControlName="confirmPassword"
            class="recovery-input"
            [placeholder]="'RECOVERY_PASSWORD.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
            autocomplete="new-password"
          />
        </div>
        <div *ngIf="hasError('confirmPassword')" class="recovery-error">
          <i class="fas fa-exclamation-circle"></i>
          {{ getErrorMessage('confirmPassword') | translate }}
        </div>

        <!-- Requisiti della password: lista da completare -->
        <div class="recovery-checklist">
          <div class="recovery-checklist-header">
            <span>{{ 'RECOVERY_PASSWORD.PASSWORD_REQUIREMENTS' | translate }}</span>
            <span class="recovery-checklist-counter"
                  [class.is-complete]="metRequirementsCount === passwordRequirements.length">
              {{ metRequirementsCount }}/{{ passwordRequirements.length }}
            </span>
          </div>
          <ul class="recovery-checklist-items">
            <li class="recovery-checklist-item"
                *ngFor="let requirement of passwordRequirements"
                [class.is-met]="requirement.met">
              <i class="fas" [ngClass]="requirement.met ? 'fa-circle-check' : 'fa-circle'"></i>
              <span>{{ requirement.labelKey | translate }}</span>
            </li>
          </ul>
        </div>

        <!-- Submit Button -->
        <button type="submit" class="recovery-btn" [disabled]="isLoading || !passwordForm.valid">
          <ng-container *ngIf="!isLoading">
            <i class="fa-solid fa-key"></i>
            {{ 'RECOVERY_PASSWORD.SUBMIT' | translate }}
          </ng-container>
          <ng-container *ngIf="isLoading">
            <i class="fa-solid fa-spinner fa-spin"></i>
            {{ 'RECOVERY_PASSWORD.PROCESSING' | translate }}
          </ng-container>
        </button>

        <!-- Footer -->
        <div class="recovery-footer">
          <a routerLink="/login">
            <i class="fa-solid fa-arrow-left"></i>
            {{ 'RECOVERY_PASSWORD.BACK_TO_LOGIN' | translate }}
          </a>
        </div>
      </form>

    </div>
  </section>

</main>
